import './vendor';
import {Swiper, Navigation, Pagination} from './vendor';
import ScrollMagic from 'scrollmagic/scrollmagic/uncompressed/ScrollMagic';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

function animationToBlock() {
	const scrollButtons = document.querySelectorAll('.js-go-to-registration');

	scrollButtons.forEach((button) => {
		button.addEventListener('click', () => {
			const targetId = button.getAttribute('data-target');
			const targetBlock = document.getElementById(targetId);

			targetBlock.scrollIntoView({
				behavior: 'smooth',
				block: 'start',
			});
		});
	});
}

function addClassForInput() {
	const inputs = document.querySelectorAll('.form__input');

	function checkValue(element) {
		if (element.value !== '') {
			element.classList.add('form__input_not-empty');
		} else {
			element.classList.remove('form__input_not-empty');
		}
	}

	for (let element of inputs) {
		checkValue(element);

		element.addEventListener('change', () => {
			checkValue(element);
		});
	}
}

function addedMaskPhone() {
	$('.js-phone-input').mask('+7 (000) 000-00-00');
}

function validationForm() {
	const form = $('.js-form-registration');

	form.validate({
		rules: {
			user_phone: {
				minlength: 18,
			},
		},
		messages: {
			user_phone: {
				minlength: 'Введите корректный номер телефона',
			},
			user_mail: {
				email: 'Введите корректный email',
			},
		},
		// eslint-disable-next-line no-shadow
		submitHandler: (form) => {
			const formData = $(form).serialize();

			let result = JSON.parse(data);

			$.ajax({
				type: 'POST',
				url: '',
				data: formData,
				success: (data) => {
					let result = JSON.parse(data);

					if (result.result !== 'error') {
						const successBlock = document.querySelector('.success');
						$(form).find('.form__input').val('').removeClass('form__input_not-empty valid');
						$('.registration__title').hide();
						$(form).hide();
						$('.success').removeClass('hidden');
					} else if (result.code === 'email') {
						// eslint-disable-next-line no-console
						console.log('ошибка отправки');
						// eslint-disable-next-line no-alert
						alert('Произошла ошибка при отправке данных');
					}
				},
				error: (error) => {
					// eslint-disable-next-line no-console
					console.error('Произошла ошибка при отправке данных: ', error);
					// eslint-disable-next-line no-alert
					alert('Произошла ошибка при отправке данных');
				},
			});
		},
	});

	$.extend($.validator.messages, {
		required: 'Это поле обязательно для заполнения',
	});
}

function initAnimationBlock() {
	const controller = new ScrollMagic.Controller();
	const blocksAnimation = document.querySelectorAll('.section-animation');

	blocksAnimation.forEach((block, item) => {
		const triggerElement = document.querySelector('.registration');
		const stylesElement = window.getComputedStyle(triggerElement);
		const paddingTopValue = parseInt(stylesElement.paddingTop, 10);

		let offsetTrigger = item === 2 ? -paddingTopValue : 0;

		// eslint-disable-next-line no-unused-vars
		const scene = new ScrollMagic.Scene({
			reverse: true,
			triggerElement: block,
			triggerHook: 0.83,
			offset: offsetTrigger,
		})
			.setClassToggle(block, 'section-animation_active')
			.addTo(controller);
			// .addIndicators();
	});
}


// класс для создание таймера обратного отсчета
class CountdownTimer {
	constructor(deadline, cbChange, cbComplete) {
		this._deadline = deadline;
		this._cbChange = cbChange;
		this._cbComplete = cbComplete;
		this._timerId = null;
		this._out = {
			days: '', hours: '', minutes: '', seconds: '',
			daysTitle: '', hoursTitle: '', minutesTitle: '', secondsTitle: ''
		};
		this._start();
	}
	static declensionNum(num, words) {
		return words[(num % 100 > 4 && num % 100 < 20) ? 2 : [2, 0, 1, 1, 1, 2][(num % 10 < 5) ? num % 10 : 5]];
	}
	_start() {
		this._calc();
		this._timerId = setInterval(this._calc.bind(this), 1000);
	}
	_calc() {
		const diff = this._deadline - new Date();
		const days = diff > 0 ? Math.floor(diff / 1000 / 60 / 60 / 24) : 0;
		const hours = diff > 0 ? Math.floor(diff / 1000 / 60 / 60) % 24 : 0;
		const minutes = diff > 0 ? Math.floor(diff / 1000 / 60) % 60 : 0;
		const seconds = diff > 0 ? Math.floor(diff / 1000) % 60 : 0;
		this._out.days = days < 10 ? '0' + days : days;
		this._out.hours = hours < 10 ? '0' + hours : hours;
		this._out.minutes = minutes < 10 ? '0' + minutes : minutes;
		this._out.seconds = seconds < 10 ? '0' + seconds : seconds;
		this._out.daysTitle = CountdownTimer.declensionNum(days, ['день', 'дня', 'дней']);
		this._out.hoursTitle = CountdownTimer.declensionNum(hours, ['час', 'часа', 'часов']);
		this._out.minutesTitle = CountdownTimer.declensionNum(minutes, ['минута', 'минуты', 'минут']);
		this._out.secondsTitle = CountdownTimer.declensionNum(seconds, ['секунда', 'секунды', 'секунд']);
		this._cbChange ? this._cbChange(this._out) : null;
		if (diff <= 0) {
			clearInterval(this._timerId);
			this._cbComplete ? this._cbComplete() : null;
		}
	}
}

function timer() {
	const elDays1 = document.querySelector('.js-timer-1 .js-timer-day');
	const elHours1 = document.querySelector('.js-timer-1 .js-timer-hours');
	const elMinutes1 = document.querySelector('.js-timer-1 .js-timer-minutes');
	const elSeconds1 = document.querySelector('.js-timer-1 .js-timer-seconds');
	const titleDays1 = document.querySelector('.js-timer-1 .js-timer-title-day');
	const titleHours1 = document.querySelector('.js-timer-1 .js-timer-title-hours');
	const titleMinutes1 = document.querySelector('.js-timer-1 .js-timer-title-minutes');
	const titleSeconds1 = document.querySelector('.js-timer-1 .js-timer-title-seconds');
	const deadline1 = new Date(2024, 4, 17, 16,0,0);
	new CountdownTimer(deadline1, (timer) => {
		elDays1.textContent = timer.days;
		elHours1.textContent = timer.hours;
		elMinutes1.textContent = timer.minutes;
		elSeconds1.textContent = timer.seconds;
		titleDays1.dataset.title = timer.daysTitle;
		titleHours1.dataset.title = timer.hoursTitle;
		titleMinutes1.dataset.title = timer.minutesTitle;
		titleSeconds1.dataset.title = timer.secondsTitle;
	}, () => {
	});

	// const elDays2 = document.querySelector('.js-timer-2 .js-timer-day');
	// const elHours2 = document.querySelector('.js-timer-2 .js-timer-hours');
	// const elMinutes2 = document.querySelector('.js-timer-2 .js-timer-minutes');
	// const elSeconds2 = document.querySelector('.js-timer-2 .js-timer-seconds');
	// const deadline2 = new Date(2024, 4, 17, 15,59,59);
	// new CountdownTimer(deadline2, (timer) => {
	// 	elDays2.textContent = timer.days;
	// 	elHours2.textContent = timer.hours;
	// 	elMinutes2.textContent = timer.minutes;
	// 	elSeconds2.textContent = timer.seconds;
	// }, () => {
	// });
}

function stepsScroll() {
	const { offsetHeight, offsetTop } = document.querySelector('.js-steps-wrapper');
	const stepsTitleItem = document.querySelectorAll('.js-steps-title span');
	const documentHeight = document.documentElement.clientHeight;
	const start = offsetTop - documentHeight / 2 - offsetHeight;
	const end = start + offsetHeight * 2;
	const spanCount = stepsTitleItem.length;
	const heightOne = (offsetHeight * 2) / spanCount;
	console.log({heightOne});

	document.addEventListener('scroll', () => {
		const { scrollY } = window;
		if (scrollY > start && scrollY < end) {
			const difference = scrollY - start;
			const coloredCount = difference / heightOne;

			stepsTitleItem.forEach((item,i) => {
				if (i < coloredCount) {
					item.style.opacity = '100%';
				} else
				{
					item.style.opacity = '60%';
				}
			})
		}

	});

}



addClassForInput();
animationToBlock();
addedMaskPhone();
validationForm();
timer();
stepsScroll();
